// *******************************************************************************
// Remove hidden Attribute From Menu
// *******************************************************************************

document.querySelectorAll('.menu').forEach((el) => {
  el.removeAttribute('hidden');
});
